import React from "react"
import * as Style from "./InfoLector.module.scss"
import { GatsbyImage } from "gatsby-plugin-image"
import Button from "../UI/button/Button"

const InfoLector = props => {
  const data = props.data
  const img = data.lecturer_img.localFile.childImageSharp.gatsbyImageData
  const heading = data.title
  const name = data.lecturer_name
  const disc = data.description
  const buttonText = data.button.button_title

  return (
    <section className={Style.lectorSection}>
      <h3 className={Style.heading}>{heading}</h3>

      <div className={Style.infoWrapper}>
        <GatsbyImage image={img} alt="lector" />

        <div className={Style.textWrapper}>
          <h4>{name}</h4>
          <p>{disc}</p>
          <div className={Style.buttonWrapper}>
            <Button style={Style.btn}>{buttonText}</Button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default InfoLector
